import { CheckCircle2, Clock3, AlertCircle, Minus } from "lucide-react";

const STATES = {
  sent: { label: "Sent", icon: CheckCircle2, color: "text-eco-bright", detail: "Accepted by the email provider. Inbox delivery is not confirmed." },
  pending: { label: "Queued", icon: Clock3, color: "text-solar-highlight", detail: "Enquiry saved. Email notification is queued." },
  sending: { label: "Sending", icon: Clock3, color: "text-solar-highlight", detail: "Sending email notification. Refresh to check the latest status." },
  failed: { label: "Not sent", icon: AlertCircle, color: "text-red-600", detail: "Email could not be sent. The enquiry is still saved." },
  unknown: { label: "Unconfirmed", icon: AlertCircle, color: "text-solar-highlight", detail: "The email provider did not confirm the result. Check your inbox; the enquiry is saved." },
};

export const EmailAlertStatus = ({ alert, leadId }) => {
  const state = STATES[alert?.status] || { label: "—", icon: Minus, color: "text-slate-400", detail: "Submitted before email alerts were enabled." };
  const Icon = state.icon;
  return (
    <span className={`inline-flex items-center gap-1.5 whitespace-nowrap text-xs font-semibold ${state.color}`}
      title={state.detail} aria-label={`${state.label}. ${state.detail}`}
      data-testid={`lead-email-status-${leadId}`}>
      <Icon size={14} aria-hidden="true" /> {state.label}
    </span>
  );
};